import { useHealthAssessment } from "@/features/health-assessment/hooks/useHealthAssessment";
import { useBloodTest } from "@/features/holifya-tests/blood-test/hooks/useBloodTest";
import { useBloodTracker } from "@/features/holifya-tests/blood-test/hooks/useBloodTracker";
import { useDnaTest } from "@/features/holifya-tests/dna-test/hooks/useDnaTest";
import { useDnaTracker } from "@/features/holifya-tests/dna-test/hooks/useDnaTracker";
import { DnaTestTrackingStatus } from "@/features/holifya-tests/dna-test/types/DnaTestTrackingStatus";
import { useGetDocuments } from "@/features/ocr/hooks/useGetDocuments";
import { BloodTestTrackingStatus } from "@/utils/enums/TrackingStatus";


export const usePercentageRing = () => {
    const { dnaTracker } = useDnaTracker()
    const { bloodTracker } = useBloodTracker()
    const { dnaTestUser } = useDnaTest()
    const { bloodTestUser } = useBloodTest()
    const { data: documents } = useGetDocuments();

    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

    const filesUploaded =
        Array.isArray(documents) &&
        documents.some((doc) => new Date(doc.createdAt) > sixMonthsAgo);


    const { isHealthAssessmentCompleted } = useHealthAssessment()
    const healthAssessmentCompleted = isHealthAssessmentCompleted()

    const getTotalDnaPercentage = () => {
        let percentage = 0;
        let numberOfItems = 0;

        switch (dnaTracker) {
            case DnaTestTrackingStatus.Purchased:
                percentage = 0;
                numberOfItems = 4;
                break;
            case DnaTestTrackingStatus.Delivered:
                percentage = 25;
                numberOfItems = 4;
                break;
            case DnaTestTrackingStatus.TestDone:
                percentage = 50;
                numberOfItems = 4;
                break;
            case DnaTestTrackingStatus.SampleRegistered:
                percentage = 75;
                numberOfItems = 4;
                break;
            case DnaTestTrackingStatus.PickupRequested:
                percentage = 100;
                numberOfItems = 4;
                break;
            // TODO [TM]: sistema i focus
            case DnaTestTrackingStatus.DeliveredToLaboratory:
                percentage = 100 / 3;
                numberOfItems = 3;
                break;
            case DnaTestTrackingStatus.StartingToExtract:
                percentage = 100 / 3;
                numberOfItems = 3;
                break;
            case DnaTestTrackingStatus.StartingAnalysis:
                percentage = 200 / 3;
                numberOfItems = 3;
                break;
            case DnaTestTrackingStatus.AnalysisDone:
                percentage = 100;
                numberOfItems = 3;
                break;
            default:
                break;
        }

        return { percentage, numberOfItems };
    };

    const getTotalBloodPercentage = () => {
        let percentage = 0;
        let numberOfItems = 0;

        switch (bloodTracker) {
            case BloodTestTrackingStatus.Purchased:
                percentage = 0;
                numberOfItems = 4;
                break;
            case BloodTestTrackingStatus.Delivered:
                percentage = 25;
                numberOfItems = 4;
                break;
            case BloodTestTrackingStatus.TestDone:
                percentage = 50;
                numberOfItems = 4;
                break;
            case BloodTestTrackingStatus.SampleRegistered:
                percentage = 75;
                numberOfItems = 4;
                break;
            case BloodTestTrackingStatus.PickupRequested:
                percentage = 100;
                numberOfItems = 4;
                break;
            case BloodTestTrackingStatus.DeliveredToLab:
                percentage = 0;
                numberOfItems = 1;
                break;
            default:
                percentage = 0;
                break;
        }

        return { percentage, numberOfItems };
    };

    const getTotalClinicalHistoryPercentage = () => {
        const multiplier = 50

        const stepsCompleted = [
            healthAssessmentCompleted,
            filesUploaded,
        ].filter(Boolean).length;

        const percentage = stepsCompleted * multiplier;

        return { percentage, numberOfItems: 2 };
    };

    const getTotaMedicalEquipePercentage = () => {
        return 0;
    };

    const isPercentageRingVisible =
        dnaTestUser && dnaTracker === DnaTestTrackingStatus.ReportGenerated ? false :
            bloodTestUser && bloodTracker === BloodTestTrackingStatus.ReportGenerated ? false :
                true

    return { getTotalDnaPercentage, getTotalBloodPercentage, getTotalClinicalHistoryPercentage, getTotaMedicalEquipePercentage, isPercentageRingVisible };
}